import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import properties from "../constantes/constImoveis";
import PropertyCard from "./PropertyCard";
import "../css/property-slider.css";

const propertyDetailsUrl = "https://www.dalmosouza.com.br/properties.html";

const PropertySlider = ({
  title = "Imóveis em destaque",
  supportingText = "Seleção especial",
}) => {
  const trackRef = useRef(null);
  const [canScrollPrevious, setCanScrollPrevious] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(true);

  const updateControls = () => {
    const track = trackRef.current;
    if (!track) return;

    setCanScrollPrevious(track.scrollLeft > 1);
    setCanScrollNext(
      track.scrollLeft + track.clientWidth < track.scrollWidth - 1,
    );
  };

  const scrollTrack = (direction) => {
    const track = trackRef.current;
    const firstCard = track?.querySelector(".property-card");
    if (!track || !firstCard) return;

    const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
    const cardWidth = firstCard.getBoundingClientRect().width;
    const visibleCards = Math.max(
      1,
      Math.floor((track.clientWidth - 4 + gap) / (cardWidth + gap)),
    );
    track.scrollBy({
      left: direction * visibleCards * (cardWidth + gap),
      behavior: "smooth",
    });
  };

  return (
    <section
      className="property-slider"
      aria-labelledby="property-slider-title"
    >
      <div className="property-slider-container">
        <header className="property-slider-heading">
          <div>
            {supportingText && (
              <p className="property-slider-eyebrow">{supportingText}</p>
            )}
            <h2 id="property-slider-title">{title}</h2>
          </div>
          <div className="property-slider-actions">
            <Link className="property-slider-all" to="/properties">
              Ver todos os imóveis
            </Link>
          </div>
        </header>

        <div className="property-slider-carousel">
          <button
            className="property-slider-arrow property-slider-arrow-previous"
            type="button"
            aria-label="Ver imóveis anteriores"
            disabled={!canScrollPrevious}
            onClick={() => scrollTrack(-1)}
          >
            <span
              className="property-slider-arrow-icon property-slider-arrow-icon-previous"
              aria-hidden="true"
            />
            <span className="property-slider-arrow-label">Anterior</span>
          </button>
          <div
            className="property-slider-track"
            ref={trackRef}
            onScroll={updateControls}
            aria-label="Imóveis disponíveis"
          >
            {properties.map((property) => (
              <PropertyCard
                key={property.code}
                property={property}
                href={`${propertyDetailsUrl}?search=${property.code}`}
              />
            ))}
          </div>
          <button
            className="property-slider-arrow property-slider-arrow-next"
            type="button"
            aria-label="Ver próximos imóveis"
            disabled={!canScrollNext}
            onClick={() => scrollTrack(1)}
          >
            <span className="property-slider-arrow-icon" aria-hidden="true" />
            <span className="property-slider-arrow-label">Próximo</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default PropertySlider;
